module.exports = __webpack_public_path__ + "img/icon_person.1d9a767b.svg";